import { useEffect } from "react";

export const SITE_URL = "https://toolsvalue.com";
export const SITE_NAME = "ToolsValue · Officina Tool Control";
export const SITE_IMAGE = `${SITE_URL}/og-cover-rocket.png`;

const upsert = (selector, create, attribute, value) => {
  let node = document.head.querySelector(selector);
  if (!node) {
    node = create();
    document.head.appendChild(node);
  }
  node.setAttribute(attribute, value);
  return node;
};

const setNamedMeta = (name, content) =>
  upsert(`meta[name="${name}"]`, () => {
    const meta = document.createElement("meta");
    meta.setAttribute("name", name);
    return meta;
  }, "content", content);

const setPropertyMeta = (property, content) =>
  upsert(`meta[property="${property}"]`, () => {
    const meta = document.createElement("meta");
    meta.setAttribute("property", property);
    return meta;
  }, "content", content);

const setCanonical = (href) =>
  upsert('link[rel="canonical"]', () => {
    const link = document.createElement("link");
    link.setAttribute("rel", "canonical");
    return link;
  }, "href", href);

const setJsonLd = (data) => {
  const existing = document.head.querySelector('script[data-seo-jsonld="true"]');
  if (existing) existing.remove();
  if (!data) return;
  const script = document.createElement("script");
  script.type = "application/ld+json";
  script.setAttribute("data-seo-jsonld", "true");
  script.textContent = JSON.stringify(data);
  document.head.appendChild(script);
};

/** Meta tag unici per pagina: titolo, descrizione, canonical, Open Graph e regole di indicizzazione. */
export function useSeo({ title, description, path = "/", noindex = false, jsonLd = null }) {
  useEffect(() => {
    const canonical = `${SITE_URL}${path === "/" ? "/" : path}`;
    document.title = title;
    setNamedMeta("description", description);
    setNamedMeta("robots", noindex ? "noindex, nofollow" : "index, follow");
    setCanonical(canonical);
    setPropertyMeta("og:title", title);
    setPropertyMeta("og:description", description);
    setPropertyMeta("og:url", canonical);
    setPropertyMeta("og:site_name", SITE_NAME);
    setPropertyMeta("og:type", "website");
    setPropertyMeta("og:locale", "it_IT");
    setPropertyMeta("og:image", SITE_IMAGE);
    setPropertyMeta("og:image:width", "1200");
    setPropertyMeta("og:image:height", "630");
    setNamedMeta("twitter:card", "summary_large_image");
    setNamedMeta("twitter:title", title);
    setNamedMeta("twitter:description", description);
    setNamedMeta("twitter:image", SITE_IMAGE);
    setJsonLd(jsonLd);
    return () => setJsonLd(null);
  }, [title, description, path, noindex, jsonLd]);
}

export const LANDING_JSON_LD = {
  "@context": "https://schema.org",
  "@type": "SoftwareApplication",
  name: "ToolsValue — Officina Tool Control",
  applicationCategory: "BusinessApplication",
  operatingSystem: "Web",
  inLanguage: "it-IT",
  url: SITE_URL,
  description:
    "PLM per officine di meccanica di precisione: anagrafica utensili e attacchi base, magazzini e giacenze, pianificazione della produzione, preventivi con costi e margini, controllo qualità e macchine utensili in un'unica piattaforma.",
  featureList: [
    "Catalogo utensili e attacchi base",
    "Magazzini, giacenze e movimenti tracciati",
    "Commesse, fasi e planner di produzione",
    "Preventivi con tempi, costo industriale, margine e offerta PDF",
    "Piani di controllo qualità e non conformità",
    "Macchine utensili, curve coppia/potenza e idoneità",
  ],
  offers: {
    "@type": "Offer",
    price: "0",
    priceCurrency: "EUR",
    description: "Prova gratuita dei piani premium, piano base gratuito",
  },
  publisher: {
    "@type": "Organization",
    name: "ToolsValue",
    url: SITE_URL,
  },
};
